'use strict';

class TrackPage {
    constructor(e) {
        jQuery('#payment-confirm').on('change', (event) => {
            if (jQuery('#payment-confirm').prop('checked')) {
                jQuery('#onlinePaymentsBtn').removeClass('disabled');
            } else {
                jQuery('#onlinePaymentsBtn').addClass('disabled');
            }
        });        
    }

    /**
     * Запрос на получения постоянной ссылки трека
     * @param form
     */
    initRequestLink(form) {
        $(form).on('beforeSubmit', () => {

            let form_group = $(form).find('.form-group');
            let url = '/ajax/create-track-link';
            let data = $(form).serializeArray();

            form_group.toggleClass('has-warning');

            let callback = (data) => {
                if (data) {
                    if (data.url) {
                        window.location = data.url;
                    }
                    if (data.error) {
                        Swal.fire({
                            title: 'Ошибка!',
                            text: data.error,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }
                }

            };

            let request = new AjaxParts(null, {
                url: url,
                data: data,
                callback: callback
            })

            request.ajaxRequest();

            return false;
        })
    }    
    initTrackSlider(){
        var slideLine = jQuery('.status-line');
        var slideCount = jQuery('.status-cell').length;
        var widthContainer = jQuery('.status-container').width();
        var widthStatus = slideLine.width();
        if (slideCount>8){
            jQuery('.track-slide-prev').css({display:'block'});
            slideLine.css({right:'30px'});        
            
            jQuery(document).on('click', '.track-slide-prev, .track-slide-next', function(e){
                
                if (jQuery(e.target).hasClass('track-slide-next')){
                    slideLine.animate({right: '30px'});
                    jQuery('.track-slide-next').fadeOut();
                    jQuery('.track-slide-prev').fadeIn();
                }else{
                    slideLine.animate({right: widthContainer-widthStatus+'px'});                
                    jQuery('.track-slide-prev').fadeOut();
                    jQuery('.track-slide-next').fadeIn();
                }
            });
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = TrackPage;
}